import React, { useState, useEffect } from 'react';
import { FaUpload, FaTimes } from 'react-icons/fa';
import './css_pages/POS.css';
import {
  getAllPOSData,
  importPOSData,
  deletePOSRecord
} from '../services/posService';
import {useStore} from '../contexts/StoreContext';

function POSData() {
  const [posData, setPosData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Estados de importación
  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const { selectedStore } = useStore();
  const [importing, setImporting] = useState(false);

  // Estados de eliminación
  const [deleteId, setDeleteId] = useState(null);

  // Filtro de búsqueda simple
  

  useEffect(() => {
    if(selectedStore){
      fetchPOSData(selectedStore.id)
    }
  }, [selectedStore]);

  const fetchPOSData = async (storeId) => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAllPOSData(storeId);
      if (response.success) {
        setPosData(response.data);
      }
    } catch (error) {
      setError('Error loading POS data');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        setSelectedFile(file);
      } else {
        alert('Please select a valid CSV file');
        e.target.value = '';
      }
    }
  };

  const handleImport = async () => {

    try {
      setImporting(true);

      const result = await importPOSData(selectedFile, selectedStore.id, (progress) => {
      });

      if (result.success) {
        alert(
          `Import completed!\n\n` +
          `Total: ${result.stats.total}\n` +
          `Imported: ${result.stats.imported}\n` +
          `Skipped: ${result.stats.skipped}\n` +
          (result.stats.errors ? `\nSome errors occurred. Check console for details.` : '')
        );

        if (result.stats.errors) {
          console.error('Import errors:', result.stats.errors);
        }

        await fetchPOSData(selectedStore.id);
        handleCloseImportModal();
      }
    } catch (error) {
      alert('Error importing data: ' + (error.response?.data?.message || error.message));
      console.error('Error:', error);
    } finally {
      setImporting(false);
    }
  };

  const handleCloseImportModal = () => {
    setShowImportModal(false);
    setSelectedFile(null);
  };

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
  };

  const handleConfirmDelete = async () => {
    try {
      setLoading(true);
      const response = await deletePOSRecord(deleteId);
      if (response.success) {
        alert('Record deleted successfully');
        await fetchPOSData(selectedStore.id);
      }
      handleCloseDeleteModal();
    } catch (error) {
      alert('Error deleting record');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  if (!selectedStore) {
    return (
      <div className="pos-data-page">
        <div className="page-header"><h1>POS Data</h1></div>
        <div className="no-store-message">
          <p>Please select a store from the sidebar to view POS data</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pos-data-page">
      {/* Header */}
      <div className="page-header sticky-header">
        <div className="header-left">
          <h1>POS Data</h1>
          {selectedStore && (
            <span className="store-indicator">
              {selectedStore.name}
            </span>
          )}
        </div>
        <div className="header-buttons">
          <button 
            className="btn-primary" 
            onClick={() => setShowImportModal(true)} 
            disabled={loading}
          >
            <FaUpload /> Import CSV
          </button>
        </div>
      </div>

      {/* Error message */}
      {error && (
        <div className="error-message">
          {error}
          <button onClick={() => fetchPOSData(selectedStore.id)}>Retry</button>
        </div>
      )}

      {/* Stats */}
      <div className="stats-bar">
        <div className="stat-item">
          <span className="stat-label">Total Records:</span>
        </div>
      </div>

      {/* Modal de Importación */}
      {showImportModal && (
        <div className="modal-overlay" onClick={handleCloseImportModal}>
          <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Import POS Data</h2>
              <button className="btn-close" onClick={handleCloseImportModal}>
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Select Store *</label>
                <p className='store-indicator'>
                  Importing to: <strong>{selectedStore?.name}</strong>
                </p>
              </div>

              <div className="form-group">
                <label>Select CSV File *</label>
                <input 
                  type="file" 
                  accept=".csv" 
                  onChange={handleFileSelect} 
                  disabled={importing}
                  className="file-input"
                />
                {selectedFile && (
                  <p style={{ marginTop: '8px', fontSize: '13px', color: '#64748b' }}>
                    Selected: {selectedFile.name}
                  </p>
                )}
              </div>

              {importing && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                  <div className="loading-spinner" />
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button 
                className="btn-secondary" 
                onClick={handleCloseImportModal} 
                disabled={importing}
              >
                Cancel
              </button>
              <button 
                className="btn-primary" 
                onClick={handleImport} 
                disabled={importing || !selectedFile || !selectedStore}
              >
                {importing ? 'Importing...' : 'Import'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default POSData;